import { render } from "./refugee_verification.html?vue&type=template&id=7230f32a&scoped=true&external"
import script from "./refugee_verification.js?vue&type=script&lang=js&external"
export * from "./refugee_verification.js?vue&type=script&lang=js&external"

import "./RefugeeVerificationReport.vue?vue&type=style&index=0&id=7230f32a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7230f32a"]])

export default __exports__